/* css-reset.tsx generated by @compiled/babel-plugin v0.17.1 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import React from "react";
var _6 = "._1k0gidpf li+li{margin-left:0}";
var _5 = "._eld4idpf li+li{margin-bottom:0}";
var _4 = "._1mwnidpf li+li{margin-right:0}";
var _3 = "._17hvidpf li+li{margin-top:0}";
var _2 = "._vwz4kb7n{line-height:1}";
var _ = "._1wyb1osq{font-size:100%}";
var cssResetStyles = null;
var CSSReset = function CSSReset(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6]), /*#__PURE__*/React.createElement("div", {
    className: ax(["_1wyb1osq _vwz4kb7n _17hvidpf _1mwnidpf _eld4idpf _1k0gidpf"])
  }, children));
};
export default CSSReset;